import { render } from "./UnderConstructionView.vue?vue&type=template&id=57d45605&scoped=true"
import script from "./UnderConstructionView.vue?vue&type=script&lang=js"
export * from "./UnderConstructionView.vue?vue&type=script&lang=js"

import "./UnderConstructionView.vue?vue&type=style&index=0&id=57d45605&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d45605"]])

export default __exports__